/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {InputField} from '../../components/Inputs/InputField';
import Select from '../../components/Inputs/Select';
import {useForm} from '../../../hooks/DemanderAvenant/useForm';
import SecondaryButton from '../../components/Button/SecondaryButton';
import { Validation } from '../../../common/utils/validationDemanderAvenant';
import { TitleLabels } from '../../../data/constants/demanderAvenant';

export const Form = (props: any) => {
  const {data, listTypeDemande, onCancelForm, onSubmitForm, listContrat} =
    props;
  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listTypeDemande,
    listContrat,
  );

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    onSubmitForm(dto.data);
  }

  return (
    <View>
      {/** form inputs */}
      <View>
        <Select
          label={TitleLabels.contractant.termeAvenantId}
          required
          name="termeAvenantId"
          value={values.termeAvenantId}
          onChange={handleChange}
          error={errors.termeAvenantId}
          showError={showErrors.termeAvenantId}
          disabled={false}
          data={listTypeDemande}
        />

        <InputField
          label={TitleLabels.contractant.message}
          required
          name="message"
          value={values.message}
          onChange={handleChange}
          error={errors.message}
          showError={showErrors.message}
          isEditable={true}
          type="textArea"
          placeholder="Votre commentaire ..."
        />
      </View>
      {/** Submit buttons */}
      <View>
        <SecondaryButton
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Valider"
        />
      </View>
    </View>
  );
};
